import React, { Suspense, useContext } from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import DSRFilterHeader from "Pages/DRS/DRSFilter/DSRFilterHeader";
import { useNavigate } from "react-router-dom";
import { useDRSContext } from "Pages/DRS/Context/DRSContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
import { DRS_DASHBOARD_ACCESS_ROLE } from "utilFunctions/Constants/Constants";
const MyBucketMain = React.lazy(
  () => import("./DRSTabs/MyBucket/MyBucketMain")
);
const DRSDashboard = React.lazy(
  () => import("./DRSTabs/Dashboard/DRSDashboard")
);
const StyledTabs = styled<any>(Tabs)`
  padding-left: ${(props: any) =>
    !["xs", "sm", "md"].includes(props.screen) ? "0px" : "0px"};
  .ant-tabs-nav {
    margin-bottom: 0;
    padding-right: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "12px" : "0px"};
    background: #fff;
    border-bottom-left-radius: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "0px" : "12px"};
    border-bottom-right-radius: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "0px" : "12px"};
  }
  .ant-tabs-nav::before {
    border: 0px !important;
  }
  .ant-tabs-tab {
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .ant-tabs-content-holder {
    height: calc(100vh - 156px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .ant-tabs-nav-wrap {
    padding-left: ${(props: any) =>
      ["xs", "sm", "md"].includes(props.screen) ? "12px" : "40px"};
    background: white;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "My Bucket",
    children: (
      <Suspense fallback={<div>Loading...</div>}>
        <MyBucketMain />
      </Suspense>
    ),
  },
  {
    key: "2",
    label: "Dashboard",
    children: (
      <Suspense fallback={<div>Loading...</div>}>
        <DRSDashboard></DRSDashboard>
      </Suspense>
    ),
  },
];
interface DRSTabsProps {
  tabIndex?: number;
  setTabIndex?: any;
}
const DRSTabs: React.FC<DRSTabsProps> = ({
  tabIndex = 0,
  setTabIndex,
}: DRSTabsProps) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { fexRole }: any = userInfo;
  const { isQuestionSessionStarted } = useDRSContext();
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const navigateToQuestion = () => {
    navigate("/admin/DRS/regions", {
      state: { from: "DRS/question" },
    });
  };
  const onChange = (key: string) => {
    setTabIndex(parseInt(key) - 1);
    if (key === "2") {
      navigateToQuestion();
    } else {
      if (isQuestionSessionStarted) {
        navigate("/admin/DRS/question/124", {
          state: { from: "DRSMain" },
        });
      } else {
        navigate("/admin/DRS");
      }
    }
  };
  return (
    <>
      <StyledTabs
        screen={screen}
        defaultActiveKey="1"
        activeKey={(tabIndex + 1).toString()}
        onChange={onChange}
        items={
          DRS_DASHBOARD_ACCESS_ROLE.includes(fexRole)
            ? items
            : items.slice(0, 1)
        }
        tabBarExtraContent={
          ["xs", "sm", "md"].includes(screen) ? (
            <DSRFilterHeader tabIndex={tabIndex} />
          ) : null
        }
      />
    </>
  );
};

export default DRSTabs;
